import api from '../token';

export const AlterFormaPagamento = async (dados) => {
  try {
    const response = await api.post('/alterFormaPagamento', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};



